/**
 * Popup Event Bus
 * Provides event publish/subscribe mechanism without business logic
 */
(function () {
  // Event bus system
  const EventBus = {
    // Emit event
    emit(eventName, data) {
      const event = new CustomEvent(eventName, { detail: data });
      document.dispatchEvent(event);
      return this;
    },

    // Listen to event
    on(eventName, callback) {
      if (typeof callback !== "function") {
        return () => {};
      }

      const handler = (e) => callback(e.detail);
      document.addEventListener(eventName, handler);

      // Return unsubscribe function
      return () => {
        document.removeEventListener(eventName, handler);
      };
    },

    // Listen once
    once(eventName, callback) {
      if (typeof callback !== "function") {
        return () => {};
      }

      const handler = (e) => {
        callback(e.detail);
        document.removeEventListener(eventName, handler);
      };
      document.addEventListener(eventName, handler);

      // Return unsubscribe function
      return () => {
        document.removeEventListener(eventName, handler);
      };
    },
  };

  // Expose to global
  window._erj_ = window._erj_ || {};
  window._erj_.PopupEventBus = EventBus;
})();
